import React, {FC, useEffect} from 'react';
import {DropsSubscribeModal} from '../../../ui/Drops/components/DropsSubscribeModal/DropsSubscribeModal';
import {useDropsSubscriptionsContext} from '../context/SubscriptionsProvider';
import {useAreDropsSubscriptionsForUser} from './useAreDropsSubscriptionsForUser';
import {useIndividualDropSubscriptionStatus} from './useIndividualDropSubscriptionStatus';
import {useIsIndividualDropSubscribed} from './useIsIndividualDropSubscribed';
import {useIsSubscribed} from './useIsSubscribed';

export const DropsSubscribeModalWrapper: FC = () => {
  const isAllDropsSubscribed = useIsSubscribed();
  const {modalData, setModalData} = useDropsSubscriptionsContext();
  const isIndividualDropSubscribed = useIsIndividualDropSubscribed(
    modalData.dropId || 0,
  );
  const isSubscribed = isIndividualDropSubscribed || isAllDropsSubscribed;

  useEffect(() => {
    setModalData({currentDrop: isIndividualDropSubscribed});
  }, [isIndividualDropSubscribed]);

  useEffect(() => {
    setModalData({allDropsSubscriptionStatus: isAllDropsSubscribed});
  }, [isAllDropsSubscribed]);

  useAreDropsSubscriptionsForUser(modalData.isOpen);
  useIndividualDropSubscriptionStatus(
    modalData.isOpen ? modalData.dropId : void 0,
  );

  return (
    <DropsSubscribeModal
      isOpen={!!modalData.isOpen}
      onRequestClose={() => {
        setModalData({
          headline: '',
          subline: '',
          backgroundImageUrl: '',
          isOpen: false,
          dropId: undefined,
          currentDrop: false,
        });
      }}
      dropId={modalData.dropId}
      backgroundImageUrl={modalData.backgroundImageUrl ?? ''}
      headline={modalData.headline ?? ''}
      subline={modalData.subline ?? ''}
      onDropSubscriptionSelectionChanged={newSelection => {
        setModalData({
          currentDrop: newSelection.currentDrop,
          allDropsSubscriptionStatus: newSelection.allDropsSubscriptionStatus,
        });
      }}
      isCurrentDropDisabled={isSubscribed}
    />
  );
};
